<template>
  <div class="w-full flex flex-col">
    <div class="flex flex-row justify-between items-center gap-2">
      <div class="flex flex-row items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M2.32022 15.9999C1.91098 15.9999 1.56508 15.8586 1.2825 15.576C0.999929 15.2934 0.858643 14.9475 0.858643 14.5383V3.09793C0.858643 2.68869 0.999929 2.34279 1.2825 2.06021C1.56508 1.77764 1.91098 1.63635 2.32022 1.63635H6.43383C6.41519 1.18651 6.56519 0.801357 6.88383 0.480905C7.20246 0.160301 7.58822 0 8.04109 0C8.49397 0 8.87949 0.160301 9.19767 0.480905C9.51585 0.801357 9.66562 1.18651 9.64699 1.63635H13.7606C14.1698 1.63635 14.5157 1.77764 14.7983 2.06021C15.0809 2.34279 15.2222 2.68869 15.2222 3.09793V14.5383C15.2222 14.9475 15.0809 15.2934 14.7983 15.576C14.5157 15.8586 14.1698 15.9999 13.7606 15.9999H2.32022ZM8.04041 2.36021C8.19798 2.36021 8.32829 2.30869 8.43132 2.20567C8.53435 2.10264 8.58586 1.97233 8.58586 1.81476C8.58586 1.65718 8.53435 1.52688 8.43132 1.42385C8.32829 1.32082 8.19798 1.26931 8.04041 1.26931C7.88283 1.26931 7.75253 1.32082 7.6495 1.42385C7.54647 1.52688 7.49496 1.65718 7.49496 1.81476C7.49496 1.97233 7.54647 2.10264 7.6495 2.20567C7.75253 2.30869 7.88283 2.36021 8.04041 2.36021ZM2.04045 13.7883C2.88893 13.0913 3.82832 12.5724 4.85861 12.2315C5.88891 11.8906 6.94951 11.7201 8.04041 11.7201C9.13131 11.7201 10.1919 11.8868 11.2222 12.2201C12.2525 12.5535 13.1919 13.0762 14.0404 13.7883V3.09793C14.0404 3.02793 14.0112 2.96384 13.9529 2.90566C13.8947 2.84733 13.8306 2.81816 13.7606 2.81816H2.32022C2.25022 2.81816 2.18613 2.84733 2.12795 2.90566C2.06962 2.96384 2.04045 3.02793 2.04045 3.09793V13.7883ZM8.04586 10.4895C8.89298 10.4895 9.61146 10.1927 10.2013 9.59925C10.791 9.00592 11.0858 8.2857 11.0858 7.43858C11.0858 6.59147 10.7891 5.87299 10.1956 5.28314C9.60229 4.69345 8.88207 4.3986 8.03495 4.3986C7.18784 4.3986 6.46936 4.69534 5.87952 5.28882C5.28982 5.88215 4.99498 6.60238 4.99498 7.44949C4.99498 8.29661 5.29172 9.01508 5.8852 9.60493C6.47853 10.1946 7.19875 10.4895 8.04586 10.4895ZM2.64704 14.8181H13.4338V14.8531C12.6551 14.212 11.807 13.7266 10.8893 13.3967C9.97138 13.0669 9.02177 12.9019 8.04041 12.9019C7.07072 12.9019 6.12929 13.0654 5.21611 13.3924C4.30294 13.7194 3.44658 14.2004 2.64704 14.8356V14.8181ZM8.04041 9.30766C7.52753 9.30766 7.08875 9.12524 6.72405 8.76039C6.35921 8.39569 6.17679 7.95691 6.17679 7.44404C6.17679 6.93116 6.35921 6.49238 6.72405 6.12768C7.08875 5.76284 7.52753 5.58041 8.04041 5.58041C8.55328 5.58041 8.99207 5.76284 9.35676 6.12768C9.72161 6.49238 9.90403 6.93116 9.90403 7.44404C9.90403 7.95691 9.72161 8.39569 9.35676 8.76039C8.99207 9.12524 8.55328 9.30766 8.04041 9.30766Z"
            fill="#696969" />
        </svg>
        <h4 class="nxp-review-title">Dados pessoais</h4>
      </div>

      <button class="nxp-review-title-action" type="button" @click="$router.push({ name: 'edit-basic-info' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M4.54 15.4993H5.46625L13.6633 7.30227L12.7371 6.37602L4.54 14.5731V15.4993ZM3.45667 16.5827V14.1164L13.8237 3.73331C13.9358 3.61886 14.0565 3.5374 14.1856 3.48893C14.3148 3.44032 14.4501 3.41602 14.5917 3.41602C14.7333 3.41602 14.8685 3.43872 14.9973 3.48414C15.1262 3.52956 15.251 3.60997 15.3717 3.72539L16.306 4.65164C16.4215 4.77234 16.5032 4.89734 16.5512 5.02664C16.5993 5.15595 16.6233 5.28907 16.6233 5.42602C16.6233 5.57199 16.5981 5.71129 16.5475 5.84393C16.4968 5.97657 16.4163 6.09782 16.306 6.20768L5.92292 16.5827H3.45667ZM13.1921 6.84727L12.7371 6.37602L13.6633 7.30227L13.1921 6.84727Z"
            fill="#4F4F4F" />
        </svg>
        Editar
      </button>
    </div>
    <hr class="custom-hr my-2" />

    <div v-if="show()" class="nxp-review-data flex flex-col px-6">
      <p v-if="email != ''">
        <b>E-mail: </b> {{ email }}
      </p>
      <p v-if="telephone != ''">
        <b>Telefone: </b> {{ telephone }}
      </p>
      <p v-if="birthday != ''">
        <b>Data de nascimento: </b> {{ birthday }}
      </p>
      <p v-if="ssn != ''">
        <b>CPF: </b> {{ ssn }}
      </p>
    </div>

    <div v-else class="w-full flex flex-col items-center justify-center space-y-4 py-8">
      <p class="nxp-review-no-data-text">
        Você ainda não preencheu suas informações pessoais.
      </p>
      <button class="nxp-review-no-data-btn" type="button" @click="$router.push({ name: 'edit-basic-info' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M8.22616 8.75597H2.58252V7.24325H8.22616V1.59961H9.73888V7.24325H15.3825V8.75597H9.73888V14.3996H8.22616V8.75597Z"
            fill="#4F4F4F" />
        </svg>
        Adicionar suas informações
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";

import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";

export default {
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("company", ["company"]),

    email() {
      return this.basicInfo != undefined ? this.basicInfo.email : "";
    },

    telephone() {
      return this.basicInfo != undefined ? this.basicInfo.telephone : "";
    },

    birthday() {
      return this.basicInfo != undefined ? this.basicInfo.birthday : "";
    },

    ssn() {
      return this.basicInfo != undefined ? this.basicInfo.ssn : "";
    },

    maritalStatus() {
      return this.basicInfo != undefined ? this.basicInfo.marital_status : "";
    },

    gender() {
      return this.basicInfo != undefined || this.basicInfo !== null
        ? this.basicInfo.gender == 0
          ? "Masculino"
          : this.basicInfo.gender == 1
            ? "Feminino"
            : "Outro"
        : "";
    },

    pcd() {
      return this.basicInfo && this.basicInfo.hasOwnProperty("pcd")
        ? this.basicInfo.pcd
        : "";
    },

    pronoun() {
      const _pronoun = get(this.$store, 'state.diversity.pronoun.name', null);
      return _pronoun ? _pronoun : 'Não informado';
    },

    socialName() {
      const _socialName = get(this.$store, 'state.diversity.social_name', null);
      return _socialName ? _socialName : 'Não informado';
    },

    color() {
      return get(this.$store, 'state.company.base_hexcolor', '#1551b1');
    },
  },

  methods: {
    show() {
      return Object.keys(this.basicInfo).length > 0;
    },
  },
  components: { EmptyDetailCard },
};
</script>

<style lang="scss">
hr {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}
</style>
